/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import SelectStyle from 'shared/enum/select.style';

import FlowBeacon from 'galax/react/map/beacon/flow';


const getOutgoingDirections = ({ zone, navigation }) =>
{
  if (navigation && navigation.getSelectStyle() == SelectStyle.Directed)
  {
    return zone.getDirections().getOutgoingWithNavigation(navigation);
  }

  return zone.getDirections().getOutgoing();
};


const getIncommingDirections = ({ zone, navigation }) =>
{
  if (navigation && navigation.getSelectStyle() == SelectStyle.Directed)
  {
    return zone.getDirections().getIncommingWithNavigation(navigation);
  }

  return zone.getDirections().getIncomming();
};


const OutgoingFlows = (props) =>
{
  if (props.incomming && !props.outgoing)
  {
    return null;
  }

  return getOutgoingDirections(props).map(index =>
  {
    return <FlowBeacon {...props} key = {index} index = {index} />
  });
}


const IncommingFlows = (props) =>
{
  if (!props.incomming)
  {
    return null;
  }

  return getIncommingDirections(props).map(index =>
  {
    return <FlowBeacon {...props} key = {index} index = {index} reverse />
  });
}


export default (props) =>
{
  if (!props.geometry.getHex().isZoneVisible())
  {
    return null;
  }

  return <><OutgoingFlows {...props} /><IncommingFlows {...props} /></>;
}
